import React from 'react';
import content2024 from "./clubTournament2024.json"
import content2023 from "./clubTournament2023.json"
import content2022 from "./clubTournament2022.json"
import content2019 from "./clubTournament2019.json"
import content2018 from "./clubTournament2018.json"
import content2017 from "./clubTournament2017.json"
import content2016 from "./clubTournament2016.json"
import content2015 from "./clubTournament2015.json"
import content2014 from "./clubTournament2014.json"
import content2013 from "./clubTournament2013.json"
import content2012 from "./clubTournament2012.json"
import {TournamentTable} from "./TournamentTable";
import {PageHero} from "../common/PageHero";

const editions = [
    {year: '2024', content: content2024},
    {year: '2023', content: content2023},
    {year: '2022', content: content2022},
    {year: '2019', content: content2019},
    {year: '2018', content: content2018},
    {year: '2017', content: content2017},
    {year: '2016', content: content2016},
    {year: '2015', content: content2015},
    {year: '2014', content: content2014},
    {year: '2013', content: content2013},
    {year: '2012', content: content2012}
];

export const ClubTournament = () => {
    return (
        <>
            <PageHero title={'Clubkampioenschap'}
                      badge={'Palmares'}
                      lead={'Elk jaar, uitgezonderd 2020 en 2021 door het corona-virus, spelen we een clubkampioenschap. Dit is een leuke manier om iedereen nog eens te zien en samen te sporten en plezier te maken. Hieronder vind je het palmares van vorige jaren.'}/>
            <div className={'ttc-section ttc-stack'}>
                {editions.map((edition) => (
                    <TournamentTable key={edition.year} date={edition.year} tableElements={edition.content}/>
                ))}
            </div>
        </>
    )
}
